import FavoritesContainer from './favorites_container'

export default FavoritesContainer
